module.exports = __webpack_public_path__ + "static/media/reverseID.4d2f7c8a.svg";